const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/app/list.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AdminAppListFilterParamSchema } from '@apps/main/features/admin/pages/app/list-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/app/list')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: AdminAppListFilterParamSchema
});